export const errorConstants = [
    {code: 'AccessDenied', message: 'شما به این بخش دسترسی ندارید'}
]
